import orderBy from 'lodash/orderBy';
import React, { useMemo } from 'react';
import { View } from 'react-native';

import { useConsumerUsageSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import { Charge } from 'apollo/queries/autogenerate/schemas';
import ChargeItem from 'shared/modules/common/components/organisms/ChargeItem';
import Separator from 'shared/modules/usage/components/molecules/ListItemDivider';
import ListSection from 'shared/modules/usage/components/molecules/ListSection';

type Props = {
  onBottomLinkPress: () => void;
  onChargeItemPress: (charge: Charge) => void;
};

export default function PlusChargesSection(props: Props) {
  const { data, error } = useConsumerUsageSummaryQuery();

  const plusCharges = data?.consumerUsageSummary.plusCharges;
  const plusChargesLength = plusCharges?.length || 0;

  const memoizedPlusCharges = useMemo(() => {
    return orderBy(plusCharges, 'pushedAt', 'desc');
  }, [plusCharges]);

  return (
    <ListSection
      title={'超あと払い'}
      emptyMessage={
        !plusCharges?.length ? '申込中の超あと払いはありません' : ''
      }
      errorMessage={error ? 'ネットワークエラー' : ''}
      bottomLinkText="契約一覧"
      onBottomLinkPress={props.onBottomLinkPress}
    >
      {memoizedPlusCharges.map((charge, index) => (
        <View key={charge.id}>
          <ChargeItem
            charge={charge as Charge}
            onPress={props.onChargeItemPress}
            hideMetaDescription={true}
            id={`plus-charges-item-${index}`}
          />
          {index !== plusChargesLength - 1 && <Separator />}
        </View>
      ))}
    </ListSection>
  );
}
